module.exports = {
      id: "fb-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#fb",
      toString: function () {
        return this.url;
      }
    }